export default __webpack_public_path__ + "static/1-42e5dc45c4894ab0ba9f17fb50512bca.png";